'use es6';

import Immutable from 'immutable';
import * as UnreviewableReasons from 'marketplace-ui-reviews/constants/UnreviewableReason';
import { cleanObject } from '../utils/formatters';
const defaults = {
  hasProfile: null,
  maxPortalReviews: 0,
  portalReviewsCount: 0,
  testPortal: null,
  userAlreadyReviewed: null,
  userOnProviderPortal: null
};
export default class ProfileReviewability extends Immutable.Record(defaults) {
  constructor(data) {
    super(cleanObject(data));
  }

  getUnreviewableReason() {
    const {
      maxPortalReviews,
      portalReviewsCount,
      testPortal,
      userOnProviderPortal,
      userAlreadyReviewed
    } = this;

    if (portalReviewsCount >= maxPortalReviews) {
      return UnreviewableReasons.LIMIT_REACHED;
    } else if (userOnProviderPortal) {
      return UnreviewableReasons.PROVIDER_USER;
    } else if (testPortal) {
      return UnreviewableReasons.TEST_PORTAL_USER;
    } else if (userAlreadyReviewed) {
      return UnreviewableReasons.ALREADY_REVIEWED;
    } else {
      return false;
    }
  }

  isReviewable() {
    return !this.getUnreviewableReason();
  }

}